import React from "react";
import { Link, useLocation } from "react-router-dom";
import GlobalSidebarMenu from "../../default/header/globalSidebarMenu";


const SidebarMenu = () => {
    const location = useLocation();
    const isActive = (path) => location.pathname === path ? 'active-menu' : '';
    return (
        <div className="card-menu-wrapper">
            <div className="sticky-area has-top-level-menu">
                <div className="top-level-menu">
                    <GlobalSidebarMenu sidebarTitle=" "/>
                </div>
                <ul>
                    <li>
                        <Link className={isActive('/user/manage')} to="/user/manage">Manage</Link>
                    </li>
                    <li>
                        <Link className={isActive('/user/profile')} to="/user/profile">Profile Details</Link>
                    </li>
                    <li>
                        <Link className={isActive('/user/password')} to="/user/password">Password update</Link>
                    </li>
                    <li>
                        <Link className={isActive('/user/settings')} to="/user/settings">Settings</Link>
                    </li>
                </ul>
            </div>
        </div>
    );
}

export default SidebarMenu;
